import { api } from "@/api";

class API {
  static getInsuranceCompany(payload) {
    return api.get(`/v1/seguradoras${payload}`);
  }
  static postInsuranceCompany(payload) {
    return api.post("/v1/seguradoras", payload);
  }
  static getPaymentMethods() {
    return api.get("/v1/formaspagamento/suggest");
  }
  static putInsuranceCompany(value) {
    return api.put(`/v1/seguradoras/${value.id}`, value.payload);
  }
  static getCurrentInsuranceCompany(payload) {
    return api.get(`/v1/seguradoras/${payload}`);
  }
  static uploadLogo(payload) {
    return api.post("/arquivos/upload", payload);
  }
  static getWalletRelationshipContact(payload) {
    return api.get(
      `/v1/seguradoras/${payload.seguradora}/contatosrelacionamento/${payload.contato}/carteira`
    );
  }
  static putMigrateWalletRelationshipContacts(value) {
    return api.put(
      `/v1/seguradoras/${value.seguradora}/contatosrelacionamento/${value.contato}/carteira/migrar`,
      value.payload
    );
  }
}

export default API;
